import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface HeroProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  buttonText?: string;
  buttonLink?: string;
}

const Hero: React.FC<HeroProps> = ({ 
  title, 
  subtitle, 
  backgroundImage, 
  buttonText = "En savoir plus", 
  buttonLink = "/animaux" 
}) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Simule un chargement pour l'animation
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      className="relative h-screen flex items-center justify-center overflow-hidden"
      style={{ 
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay foncé pour un meilleur contraste */}
      <div className="absolute inset-0 bg-black opacity-40 z-10"></div>
      
      {/* Animation d'éclatement de particules */}
      <div className="absolute inset-0 z-0">
        {Array.from({ length: 20 }).map((_, i) => (
          <div 
            key={i}
            className={`
              absolute bg-yellow-400 rounded-full opacity-30
              animate-pulse motion-safe:animate-ping
              ${loaded ? 'opacity-30' : 'opacity-0'}
              transition-opacity duration-1000 ease-out
            `}
            style={{
              width: `${Math.random() * 10 + 5}px`,
              height: `${Math.random() * 10 + 5}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDuration: `${Math.random() * 3 + 2}s`,
              animationDelay: `${Math.random() * 2}s`,
            }}
          ></div>
        ))}
      </div>
      
      {/* Contenu du héro */}
      <div 
        className={`
          container mx-auto px-6 relative z-20 text-center
          transform transition-all duration-1000 ease-out
          ${loaded ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}
        `}
      >
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg">
          {title}
        </h1>
        <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto drop-shadow-md">
          {subtitle}
        </p>
        {buttonText && (
          <Link 
            to={buttonLink} 
            className="
              inline-block bg-yellow-500 hover:bg-yellow-600 
              text-white font-semibold py-3 px-8 
              rounded-full transition-all duration-300
              transform hover:scale-105 hover:shadow-lg
            "
          >
            {buttonText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default Hero;
